export const AUTH_CONFIG = {
	AUTH_TOKEN_KEY: 'token',
	AUTH_USER_KEY: 'user',
	AUTH_REGION_KEY: 'region',
	AUTH_USERNAME_KEY: 'username',
}